import styled from "styled-components";

export const Summary =styled.h4`
margin: 0;
paddinf:0;
fontSize:1rem;
`